import React, { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';

import { PageRootWrapper } from '@/components/shared/PageRootWrapper';

type Props = {
  children?: ReactNode;
};

export const Done: React.FC<Props> = ({ children }) => {
  const { t } = useTranslation();
  const title = t('pages.subscription.new.done.title');
  const items = [{ label: title }];

  return (
    <PageRootWrapper
      title={title}
      headerTitle={title}
      breadcrumbItems={items}
      containerType="normal"
    >
      {children}
    </PageRootWrapper>
  );
};
